<template>
  <div style="margin-top: 73px">
    <div
      class="mobile-footer"
      :class="{
        'panel-width':
          ($route.name == 'OTC' && state.token) ||
          $route.path.includes('dashboard'),
      }"
    >
      <router-link
        :to="{ name: item.to }"
        v-for="(item, index) in mobileLink"
        :key="index"
        :class="{ 'active-link': $route.name == item.to }"
      >
        <InlineSvg :src="item.icon" class="icon" />
        <span>{{ item.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  components: { InlineSvg },
  data() {
    return {
      mobileLink: [
        {
          title: "خانه",
          icon: require("@/assets/icons/home-solid.svg"),
          to: "HomePage",
        },
        {
          title: "خرید آسان",
          icon: require("@/assets/icons/coins-solid.svg"),
          to: "OTC",
        },
        {
          title: "بازار‌ها",
          icon: require("@/assets/icons/store-solid.svg"),
          to: "Market",
        },
        {
          title: "کیف پول",
          icon: require("@/assets/icons/wallet-bifold.svg"),
          to: "Wallet",
        },
        {
          title: "تنظیمات",
          icon: require("@/assets/icons/cog.svg"),
          to: "Settings",
        },
      ],
    };
  },
};
</script>
<style scoped>
.panel-width {
  width: calc(100% - 90px) !important;
  @media (max-width: 600px) {
    width: calc(100% - 40px) !important;
  }
}
.mobile-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--box);
  box-shadow: 0 0 20px #777;
  z-index: 10;
  > a {
    color: var(--dark-grey);
    fill: var(--dark-grey);
    &.active-link {
      color: var(--primary-color) !important;
      fill: var(--primary-color) !important;
      font-weight: 700;
    }
    .icon {
      width: 20px !important;
      height: 20px !important;
      display: block;
      margin: auto;
    }
    span {
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>
